import { useClient } from '@/lib/_API/useClient';
import { useMypageStore } from '@/stores/mypage';
import { computed } from 'vue';

export function useUserData() {
  const { getClientInfo, getClientUnitInfo } = useClient();

  const setupUserData = async () => {
    const mypageStore = useMypageStore();
    const { client, center, group, tos } = await getClientInfo();
    mypageStore.updateClient(client);
    mypageStore.updateCenter(center);
    mypageStore.updateGroup(group);
    mypageStore.updateMarketing(tos.marketing);

    const clientUnitInfo = await getClientUnitInfo();
    mypageStore.updateUnit(clientUnitInfo);
  };

  return {
    setupUserData,
  };
}

type PendingGroup = {
  _id: string;
  groupName: string;
};
interface UserUnitPrivilege {
  unitAuth: 'none' | 'pending' | 'member' | 'groupHost' | 'unitAdmin';
  pendigGroups: PendingGroup[] | [];
  clientId?: string;
}

export function useComposition() {
  const mypageStore = useMypageStore();

  /**
   * 유닛관리에 대한 권한
   */
  const userUnitPrivilege = computed<UserUnitPrivilege>(() => {
    if (!mypageStore.unit)
      return {
        unitAuth: 'none',
        pendigGroups: [],
        clientId: '',
      };
    const { participantUnitId, unitRole, groupRoles, pendingGroups, clientId } =
      mypageStore.unit as api.client.getInfo.clientUnitInfo;

    const clientUnitInfo = {
      participantUnitId: participantUnitId,
      unitRole: unitRole,
      groupRoles: groupRoles,
      pendingGroups: pendingGroups,
    };
    let authAndPending: UserUnitPrivilege = {
      unitAuth: 'none',
      pendigGroups: [...clientUnitInfo.pendingGroups],
      clientId: clientId,
    };
    if (clientUnitInfo.participantUnitId === null) {
      authAndPending.unitAuth = clientUnitInfo.pendingGroups.length ? 'pending' : 'none';
    } else if (clientUnitInfo.unitRole === 'unitAdmin') {
      authAndPending.unitAuth = 'unitAdmin';
    } else if (clientUnitInfo.groupRoles.includes('host')) {
      authAndPending.unitAuth = 'groupHost';
    } else {
      authAndPending.unitAuth = 'member';
    }

    return authAndPending;
  });

  return { userUnitPrivilege };
}
